import { useState } from 'react';
import ProfileSidebar from '../components/public/ProfileSidebar';
import MobileNavigation from '../components/public/MobileNavigation';
import HomePage from './public/HomePage';
import ProjectsPage from './public/ProjectsPage';
import ToolsPage from './public/ToolsPage';
import TestimonialsComingSoon from './public/TestimonialsComingSoon';
import CaseStudyPage from './public/CaseStudyPage';

const pages = {
  home: HomePage,
  projects: ProjectsPage,
  stack: ToolsPage,
  testimonials: TestimonialsComingSoon,
  'agrivit-case-study': CaseStudyPage,
};

const Home = () => {
  const [activeSection, setActiveSection] = useState('home');
  const ActivePage = pages[activeSection] || HomePage;

  return (
    <div className="min-h-screen bg-[#0A0A0B] text-[#EDEDEF] lg:grid lg:grid-cols-[320px_minmax(0,1fr)]">
      <aside className="hidden border-b border-[#27272A] px-3 sm:px-6 lg:sticky lg:top-0 lg:block lg:h-screen lg:border-b-0 lg:border-r lg:px-4">
        <ProfileSidebar activeSection={activeSection} onNavigate={setActiveSection} />
      </aside>

      <main className="min-w-0 bg-[#0A0A0B] px-4 pb-24 pt-0 sm:px-6 lg:border-l lg:border-[#27272A] lg:px-8 lg:py-16 xl:px-10 2xl:px-12">
        <MobileNavigation activeSection={activeSection} onNavigate={setActiveSection} />
        <div className="mx-auto w-full max-w-[980px]">
          <ActivePage onNavigate={setActiveSection} />
        </div>
      </main>
    </div>
  );
};

export default Home;

